import { InjectionToken } from '@angular/core';

export interface TriadSentryConfig {
  dsn: string;
  release: string;
}
export const TriadSentryConfigToken = new InjectionToken<TriadSentryConfig>('TRIAD_SENTRY_CONFIG');
